export default __webpack_public_path__ + "e4b7c5ea705c6cbdd4086c478564732a.png";